import "../Helpers/Polyfill/ArrayFrom";

import { mobile } from "./Agent";

// var metaTags = Array.from(window.document.getElementsByTagName("meta"));
// var urlToShare =  (window.location != window.parent.location) ? document.referrer : document.location.href;
var urlToShare =  "https://www.ynet.co.il/news/gameelections2022";
var textToShare = `בואו לשחק ב״משחק הכיסאות״ ולהרכיב את הקואליציה שלכם בכנסת ה-25 >> ${urlToShare}`;

const shareFacebook = () => {
  window.dataLayer.push({
    event: "GA_events",
    Category: "Elections chair game",
    Action: "Share",
    Label: "Facebook",
  });
  window.open(
    "http://www.facebook.com/share.php?u=" + encodeURIComponent(urlToShare),
    "_blank"
  );
};

const shareTwitter = () => {
  window.dataLayer.push({
    event: "GA_events",
    Category: "Elections chair game",
    Action: "Share",
    Label: "Twitter",
  });
  window.open(
    "https://twitter.com/intent/tweet?text=" + encodeURIComponent(urlToShare),
    "_blank"
  );
};

const shareWhatsapp = () => {
    window.dataLayer.push({
        event: "share_events",
        Category: "Social",
        Action: "Share From Site Head",
        Label: "Whatsapp",
    });
    window.open(
        "https://api.whatsapp.com/send?phone=&text=" + encodeURIComponent(textToShare),
        "_parent"
    );

    //if (mobile()) {
    //  window.open(
    //    "whatsapp://send?text=" + encodeURIComponent(textToShare),
    //    "_parent"
    //  );
    //} else {
    //  window.open(
    //    "https://api.whatsapp.com/send?phone=&text=" +
    //      encodeURIComponent(textToShare),
    //    "_blank"
    //  );
    //}
};

const openNegishut = () => {
  window.document.getElementById("INDmenu-btn").click();
};

export { shareFacebook, shareTwitter, shareWhatsapp, openNegishut };



// WEBPACK FOOTER //
// ./src/Components/Services/Sharing.js